import PropTypes from 'prop-types';
import classNames from "classnames";
import React, { useState, useEffect } from 'react';
import Icon from '../Icon';
import styles from './PianoDownloadTableModal.module.scss';
import SingleChooser from '../SingleChooser';
import Cookies from 'js-cookie';
import { httpGet } from '../../utils/Http';
import { keysToCamelFromSnake } from '../../utils/caseconverters';

const NEXT_PUBLIC_API_DOMAIN = process.env.NEXT_PUBLIC_API_DOMAIN;

const allAttributes = [
    'Stereo sampled',
    'Detailed velocity mapping',
    'String resonance*',
    'Fully mapped keyboard',
];

const attributes = {
    xl: allAttributes,

    l: ['Stereo sampled', 'Detailed velocity mapping', 'String resonance*'],
    m: ['Stereo sampled', 'Detailed velocity mapping', 'String resonance*'],
    s: ['Stereo sampled', 'Detailed velocity mapping'],
};

const PianoDownloadTableModal = ({ title, downloads = [], modalText, triggerProductChooser = false, pageType, onDownload }) => {
    const [_dls, setDls] = useState(Array.isArray(downloads) ? downloads : []);
    const [compatibleProducts, setCompatibleProducts] = useState([]);
    const selectedProductFromCookie = Cookies.get('selected_product')
        ? Number(Cookies.get('selected_product'))
        : undefined;
    const [selectedProductId, setSelectedProductId] = useState(
        selectedProductFromCookie
    );

    const selectedCompatibleProduct =
        selectedProductId &&
        compatibleProducts.find((x) => x.value === Number(selectedProductId));
        

    const handleDownload = (downloadLink, download) => {

        window.location = downloadLink;

        const selectedDownload = {
            ...download,
            selectedProduct: selectedCompatibleProduct ? selectedCompatibleProduct.label : null
        }        
        if (onDownload) {

            onDownload(selectedDownload);
        }

        setTimeout(() => {
            const el = document.getElementById('modal-close-button');
            if (el) {
                el.click();
            }
        }, 1000 * 4);
    };

    useEffect(() => {
        let url = NEXT_PUBLIC_API_DOMAIN + downloads;
        if (selectedProductId) {
            url += selectedProductId + '/';
        }

        httpGet(url).then((data) => {
            setDls(keysToCamelFromSnake(data.downloads));
            setCompatibleProducts(
                keysToCamelFromSnake(data).compatibleProducts
            );
        });
    }, [selectedProductId]);

    const hasSelectedProduct =
        (!compatibleProducts.length && selectedProductFromCookie) ||
        selectedProductId;

    const showProductChooser = !hasSelectedProduct && triggerProductChooser;



    return (
        <div className={styles['PianoDownloadTableModal']}>
            <h5 className={styles['PianoDownloadTableModal__Title']}>
                Download <b>{title}</b>
            </h5>
            {modalText && (
                <p className={styles['PianoDownloadTableModal__Description']}>
                    {modalText}
                </p>
            )}

            {showProductChooser && (
                <>
                    <p
                        className={
                            styles['PianoDownloadTableModal__Description']
                        }>
                        Select your product to see available files*
                    </p>
                    <div
                        className={
                            styles['PianoDownloadTableModal__ProductChooser']
                        }>
                        <SingleChooser
                            modifiers={['alternative']}
                            tiny={true}
                            placeholder={
                                selectedCompatibleProduct
                                    ? selectedCompatibleProduct.label
                                    : 'Select product'
                            }
                            onChange={(value) => setSelectedProductId(value)}
                            tooltip={
                                'Choose your product to see compatible downloads'
                            }
                            options={compatibleProducts}
                            activeValue={selectedCompatibleProduct?.value}
                            hideClearButton={true}
                        />
                    </div>
                    <p className={styles['PianoDownloadTableModal__Help']}>
                        *Products not listed are not compatible with the
                        selected sound
                    </p>
                </>
            )}
            {!showProductChooser && (
                <div className={styles['PianoDownloadTableModal__ListWrapper']}>
                    <ul className={styles['PianoDownloadTableModal__List']}>
                        {_dls.map((download) => (
                            <li
                                key={download.downloadUrl}
                                className={
                                    styles['PianoDownloadTableModal__ListItem']
                                }>
                                <p
                                    className={classNames(
                                        styles['PianoDownloadTableModal__ListSize'],
                                        {
                                           [styles['PianoDownloadTableModal__ListSize--showDashes']]: !download.fileTitle
                                        }
                                    )}>
                                    {download.fileTitle
                                        ? download.fileTitle
                                        : (download.size.toUpperCase() + " version") }
                                </p>
                                {!download.fileTitle && <p
                                    className={
                                        styles[
                                            'PianoDownloadTableModal__ListTitle'
                                        ]
                                    }>
                                    {title}
                                </p>}
                                {download.versionName && !download.fileTitle && (
                                    <p
                                        className={
                                            styles[
                                                'PianoDownloadTableModal__ListVersion'
                                            ]
                                        }>
                                        {`v${download.versionName}`}
                                    </p>
                                )}

                                <div
                                    className={
                                        styles[
                                            'PianoDownloadTableModal__ListDownloadWrapper'
                                        ]
                                    }>
                                    <p
                                        className={
                                            styles[
                                                'PianoDownloadTableModal__ListFileSize'
                                            ]
                                        }>
                                        {download.fileSize}
                                    </p>
                                    <a
                                        href={download.downloadUrl}
                                        onClick={(event) => {
                                            event.preventDefault();
                                            handleDownload(
                                                download.downloadUrl,
                                                download
                                            );
                                            
                                        }}
                                        className={
                                            styles[
                                                'PianoDownloadTableModal__ListDownload'
                                            ]
                                        }>
                                        <span
                                            className={
                                                styles[
                                                    'PianoDownloadTableModal__ListIcon'
                                                ]
                                            }>
                                            <span className="sr-only">
                                                Download
                                            </span>
                                            <Icon
                                                type="download"
                                                size="large"
                                            />
                                        </span>
                                    </a>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

PianoDownloadTableModal.propTypes = {
    title: PropTypes.string,
};

export default PianoDownloadTableModal;
